<template>
    <Breadcrumbs main="Knowledgebase" title="Knowledgebase" />
    <div class="container-fluid">
        <div class="row">
            <knowledgebaseSearch />
            <faqWidgets />
            <browseArticles />
            <featuresFaq />
            <latestArticles />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const knowledgebaseSearch = defineAsyncComponent(() => import("@/components/theme/knowledgebase/knowledgebaseSearch.vue"))
const faqWidgets = defineAsyncComponent(() => import("@/components/theme/knowledgebase/faqWidgets.vue"))
const browseArticles = defineAsyncComponent(() => import("@/components/theme/knowledgebase/browseArticles.vue"))
const featuresFaq = defineAsyncComponent(() => import("@/components/theme/knowledgebase/featuresFaq.vue"))
const latestArticles = defineAsyncComponent(() => import("@/components/theme/knowledgebase/latestArticles.vue"))
</script>